(()=>{
  const normaliseHeader=()=>{
    document.querySelectorAll('.shy-nav-group--shop a,.shy-mobile-panel a').forEach(link=>{
      const href=link.getAttribute('href')||'';
      const label=(link.textContent||'').trim().toLowerCase();
      if(href==='/pages/treatments/jewellery-styling-fitting'||label.includes('jewellery styling + fitting')) link.remove();
    });
  };
  normaliseHeader();
  const header=document.querySelector('.shy-header');
  if(header){new MutationObserver(normaliseHeader).observe(header,{childList:true,subtree:true});}

  const desktop=window.matchMedia('(min-width: 990px) and (hover: hover)');
  const groups=[...document.querySelectorAll('.shy-nav-group')];
  const wrap=document.querySelector('.shy-header__inner')||header;
  if(!groups.length||!wrap)return;
  document.documentElement.classList.add('shy-nav-js');
  const GUTTER=20;
  const SWITCH_DELAY=110;
  let active=null;
  let switchTimer=null;
  const place=(group)=>{
    const panel=group.querySelector('.shy-mega');
    if(!panel)return;
    panel.style.setProperty('--shy-mega-shift','0px');
    const w=wrap.getBoundingClientRect();
    const r=panel.getBoundingClientRect();
    let shift=0;
    if(r.right>w.right-GUTTER)shift=(w.right-GUTTER)-r.right;
    if(r.left+shift<w.left+GUTTER)shift=(w.left+GUTTER)-r.left;
    panel.style.setProperty('--shy-mega-shift',Math.round(shift)+'px');
  };
  const setExpanded=(group,expanded)=>{
    if(!group)return;
    group.classList.toggle('is-shy-open',expanded);
    const trigger=group.querySelector('.shy-nav-parent');
    if(trigger)trigger.setAttribute('aria-expanded',expanded?'true':'false');
  };
  const close=(group,restoreFocus=false)=>{
    if(!group)return;
    if(group._shyClose)clearTimeout(group._shyClose);
    setExpanded(group,false);
    if(active===group)active=null;
    if(restoreFocus){const trigger=group.querySelector('.shy-nav-parent');if(trigger)trigger.focus();}
  };
  const open=(group)=>{
    if(!desktop.matches)return;
    clearTimeout(switchTimer);
    if(group._shyClose)clearTimeout(group._shyClose);
    if(active&&active!==group)close(active);
    place(group);
    setExpanded(group,true);
    active=group;
  };
  const requestOpen=(group)=>{
    if(!desktop.matches)return;
    if(group._shyClose)clearTimeout(group._shyClose);
    if(active&&active!==group){clearTimeout(switchTimer);switchTimer=setTimeout(()=>{if(group.matches(':hover'))open(group);},SWITCH_DELAY);return;}
    open(group);
  };
  const queueClose=(group)=>{
    clearTimeout(switchTimer);
    if(group._shyClose)clearTimeout(group._shyClose);
    group._shyClose=setTimeout(()=>close(group),420);
  };
  groups.forEach(group=>{
    setExpanded(group,false);
    place(group);
    group.addEventListener('mouseenter',()=>requestOpen(group));
    group.addEventListener('mouseleave',()=>queueClose(group));
    group.addEventListener('focusin',()=>open(group));
    group.addEventListener('focusout',event=>{if(!group.contains(event.relatedTarget))queueClose(group);});
    group.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();close(group,true);}});
  });
  document.addEventListener('pointerdown',event=>{if(active&&!active.contains(event.target))close(active);});
  let resizeTimer;
  window.addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>groups.forEach(place),120);});
  desktop.addEventListener('change',()=>{groups.forEach(group=>close(group));groups.forEach(place);});
})();

/* Treatment label clean-up only. The treatment renderer owns hero imagery. */
(()=>{
  const run=()=>{
    const root=document.querySelector('.stx');
    if(!root)return;
    const replacements=new Map([
      ['Useful to know','A few things before you book'],
      ['Before your treatment','Before you come in'],
      ['During your treatment','What it\u2019s like'],
      ['Suitability','A quick check'],
      ['Before your appointment','Before you come in'],
      ['What to expect','What it\u2019s like'],
      ['Important','A quick check'],
      ['Related treatments','Also at SHY'],
      ['ABOUT THE TREATMENT','THE DETAILS'],
      ['The treatment, explained.','How it works.']
    ]);
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(node=>{
      const value=node.nodeValue.trim();
      if(replacements.has(value)) node.nodeValue=node.nodeValue.replace(value,replacements.get(value));
    });
    root.querySelectorAll('.stx__work-head p').forEach(p=>{
      if(p.textContent.trim()==='A real finished result from SHY.')p.remove();
    });
    const handle=root.dataset?.shyTreatment||document.querySelector('article[data-shy-treatment]')?.dataset?.shyTreatment;
    if(handle==='brows-lashes'||handle==='lash-lift'){
      root.querySelectorAll('.stx__work figcaption').forEach(c=>{if(c.textContent.trim()==='Lash Lift')c.remove();});
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true}); else run();
})();

/* Labelled SHY lash/brow photographs. */
(()=>{
  const run=()=>{
    const root=document.querySelector('article.stx[data-shy-treatment]');
    if(!root)return;
    const handle=root.dataset.shyTreatment;
    const setImage=(img,src,alt,position='50% 40%')=>{
      if(!img)return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src=src;
      img.alt=alt;
      img.style.objectPosition=position;
    };
    if(handle==='brows-lashes'){
      setImage(root.querySelector('.stx__hero-media img'),'https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-lashes-brows-result-blue-eyes.jpg?v=1789333542','Lash and brow treatment result at SHY in Lewes','50% 35%');
      const work=root.querySelector('.stx__work-grid');
      if(work&&!work.dataset.shyMediaRefreshed){
        work.dataset.shyMediaRefreshed='true';
        work.classList.add('stx__work-grid--lashes-feedback');
        work.innerHTML='<figure><img src="https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-lashes-brows-result-blue-eyes.jpg?v=1789333542&width=900" width="1157" height="1536" loading="lazy" alt="Lash and brow treatment result at SHY in Lewes"></figure><figure><img src="https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-lashes-brows-result-closeup.jpg?v=1789333547&width=900" width="1157" height="1536" loading="lazy" alt="Close-up lash and brow treatment result at SHY in Lewes"></figure><figure><img src="https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-lashes-brows-result-red-hair.jpg?v=1789333563&width=900" width="1157" height="1536" loading="lazy" alt="Lash and brow treatment result at SHY in Lewes"></figure>';
      }
    }
    if(handle==='lash-lift'){
      setImage(root.querySelector('.stx__hero-media img'),'https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-lash-lift-result-studio-2026.jpg?v=1789376939','Lash lift result at SHY in Lewes','50% 38%');
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true}); else run();
})();

/* Event dates, Bridal flow, Lip Blush comparison, SPMU overview. */
(()=>{
  const run=()=>{
    document.querySelectorAll('.shy-event-card--live .shy-event-card__plate--live span').forEach(span=>{
      const card=span.closest('.shy-event-card');
      const date=card?.querySelector('.shy-event-card__date')?.textContent?.split('·')[0]?.trim()?.replace(/\s+\d{4}\s*$/,'');
      span.textContent=date||'On now';
    });

    const root=document.querySelector('article.stx[data-shy-treatment]');
    if(!root)return;
    const handle=root.dataset.shyTreatment;

    if(handle==='bridal'){
      const gallery=root.querySelector('.stb__gallery');
      const timeline=root.querySelector('.stb__timeline');
      const world=root.querySelector('.stb__world');
      if(gallery&&timeline){gallery.after(timeline);if(world)timeline.after(world);}
    }

    if(handle==='lip-blush'&&!root.querySelector('[data-shy-lip-compare]')){
      const anchor=root.querySelector('.stx__menu')||root.querySelector('.stx__family')||root.querySelector('.stx__story');
      if(anchor){
        const section=document.createElement('section');
        section.className='shy-lip-compare';
        section.dataset.shyLipCompare='true';
        section.innerHTML='<div class="shy-lip-compare__head"><h2>Before + after</h2><p>The same lips before treatment and immediately after Lip Blush with Sabrina.</p></div><div class="shy-lip-compare__grid"><figure><span class="shy-lip-compare__tag">Before</span><img src="https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-lip-blush-before-new-2026.jpg?v=1789376872&width=900" width="1157" height="1536" loading="lazy" alt="Before lip blush treatment by Sabrina at SHY in Lewes"></figure><figure><span class="shy-lip-compare__tag">After</span><img src="https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-lip-blush-after-new-2026.jpg?v=1789377024&width=900" width="1157" height="1536" loading="lazy" alt="After lip blush treatment by Sabrina at SHY in Lewes"></figure></div>';
        anchor.after(section);
      }
    }

    if(handle==='spmu'&&!root.querySelector('[data-shy-spmu-results]')){
      const anchor=root.querySelector('.stx__family')||root.querySelector('.stx__menu')||root.querySelector('.stx__story');
      if(anchor){
        const section=document.createElement('section');
        section.className='shy-spmu-results';
        section.dataset.shySpmuResults='true';
        section.innerHTML='<div class="shy-spmu-results__head"><h2>Recent work</h2><p>Fine hairstroke brows, Lip Blush and eyeliner, with the full treatment details on each service page.</p></div><div class="shy-spmu-results__grid"><figure><img src="https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-microblading-result-natural.jpg?v=1789155743&width=900" width="1070" height="1536" loading="lazy" alt="Natural microblading result by Sabrina at SHY in Lewes"></figure><figure><img src="https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-lip-blush-after-new-2026.jpg?v=1789377024&width=900" width="1157" height="1536" loading="lazy" alt="Lip blush result by Sabrina at SHY in Lewes"></figure><figure><img src="https://cdn.shopify.com/s/files/1/1092/9163/5027/files/shy-eyeliner-result-green-eyes-2026.jpg?v=1789376952&width=900" width="1376" height="1536" loading="lazy" alt="Eyeliner treatment result by Sabrina at SHY in Lewes"></figure></div>';
        anchor.after(section);
      }
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true}); else run();
})();
